import React, {useState, useEffect} from 'react'
import Header from '../../components/header/Header'
import ScheduleWrapper from './ScheduleWrapper'
import ExchangeRate from './exchangeRate'
import Orders from './orders/Orders'
import BuyOrder from './orders/BuyOrder'
import {ReactComponent as BuyApprovedIco} from '../../assets/icons/main/buy-message-approved.svg'
import {ReactComponent as BuyErrorIco} from '../../assets/icons/main/buy-message-error.svg'
// import './Main.css'
import axios from "axios";
import Market from "../main/market/Market";
import { useTranslation } from 'react-i18next'

const MainResources = () => {
    const {t} = useTranslation()
    const [buyOrderstate, setBuyOrderState] = useState(false)
    const [marketState, setMarketState] = useState(false)
    const [message, setMessage] = useState({msg: t("main.successfullyPlaced"), status: "error"}) //status "error"/"approved"


    const url = new URL(document.location.href);
    let symbolMarket = (url.searchParams.get('resource')) || "GOLDUSD";
    let match = symbolMarket.match(/(\w+)(USDT|RUB|USD)/);


    const token = localStorage.getItem("token")
    const [userBalance, setUserBalance] = useState(0);
    const requireUserBalance = () => axios.get(
        `https://api-ru.fynex.cc/api/api/users/balance/invest`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            setUserBalance(res.data[`${match[2].toLowerCase()}`]);
        });

    const [AVGdata, setAVGdata] = useState([]);
    const [marketInfo, setMarketInfo] = useState([]);
    const [isLoadedMarketInfo, setIsLoadedMarketInfo] = useState(false)



    const getFrame = () => {
        switch (symbolMarket) {
            case "GOLDUSD":
                return ("COMEX:GC1!");
                break;
            case "SILVERUSD":
                return ("COMEX:SI1!");
                break;
            case "COPPERUSD":
                return ("COMEX:HG1!");
                break;
            case "XAUUSD":
                return ("TSX:XAU");
                break;
            case "BRENTUSD":
                return ("BLACKBULL:BRENT");
                break;
            case "WTIUSD":
                return ("BLACKBULL:WTI");
                break;
            default:
                // Выполняется, если символ не найден
                console.log("Не удалось найти символ");
        }
    }
    const frame = getFrame()
    const requireAVGdata = () => axios.get(`https://api-ru.fynex.cc/api/api/share/get_avg?symbol=${match[1]}`)
        .then(res => {
            setAVGdata(res.data);
            setTimeout(() => requireAVGdata(), 20000)
        })
        .catch((err) => {console.error(err)})

    useEffect(() => {
        setTimeout(() => {
            requireAVGdata()
        }, 2000)
        requireUserBalance()
    }, [])
    const [ordersKey, setOrdersKey] = useState(0);

    const reloadUserData = () => {
        setOrdersKey(prevKey => prevKey + 1);
    }
    const [orderType, setOrderType] = useState(1)
    return (
        <div className='main'>

            {/* <div className={"opening-wrapper"} style={buyOrderstate ? {visibility: "visible"} : {visibility: "hidden"}}> */}
                {/* <div className={message.status === "approved" ? "message message-approved" : "message message-error"}>
                    {message.status === "approved" ? <BuyApprovedIco/> : <BuyErrorIco/>}
                    <p>{message.msg}</p>
                </div> */}
                {/* <BuyOrder orderType={orderType} setOrderType={setOrderType} balance={userBalance} reloadUserData={reloadUserData} coinFrom={match[2]} coinTo={match[1]} AVGdata={AVGdata} stateActive={buyOrderstate} setStateActive={setBuyOrderState}/> */}
            {/* </div> */}

            <div className="opening-market" style={marketState ? {visibility: "visible"} : {visibility: "hidden"}}>
                <Market stateActive={marketState} setStateActive={setMarketState}/>
            </div>

            <div className="main-wrapper">
                <Header deposit={true} hasMenu={true}/>
                <ExchangeRate AVGdata={AVGdata} setMarketState={() => setMarketState(true)} symbolMarket={symbolMarket} coinTo={match[1]}/>
                <ScheduleWrapper frame={frame} symbolMarket={symbolMarket} coinFrom={match[2]} coinTo={match[1]}
                    buyOrderComponent={<BuyOrder orderType={orderType} setOrderType={setOrderType} balance={userBalance} reloadUserData={reloadUserData} coinFrom={match[2]} coinTo={match[1]} AVGdata={AVGdata} stateActive={buyOrderstate} setStateActive={setBuyOrderState}/>}
                />

                <Orders setOrderType={setOrderType} ordersKey={ordersKey} setStateBuyOrder={setBuyOrderState}/>
            </div>
        </div>
    )
}
export default MainResources